module.exports = __webpack_public_path__ + "static/media/зерносушка-колонна.231194ab.png";